
























import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {  }
})
export default class DebitCardTransactionModal extends Vue {
  themeStore = useThemeStore();

  @Prop()
  showModal: boolean;

  handleOnEditClose () {
    this.$emit("handle-close");
  }
}
